import { routesConfig } from "../config/routes";
import { StorageEndpoint } from "../modules/storage/models/storage-dto";

export const useStorageEndpoint = (): StorageEndpoint => {
  const { hash } = window.location;
  const slug = hash.split("#")[1];
  return slug === routesConfig.STORAGE().RIVER_DISCHARGES
    ? "unload"
    : "retrieval";
};
